import { RouteObject } from 'react-router-dom';

import { lazyImport } from '../../../utils/lazyImport';

import NotFound from '../../../components/common/NotFound';

const GetCare = lazyImport(() => import('../Components/get-care'), 'default').default;
const Questionnaire = lazyImport(() => import('../../questionnaire'), 'default').default;
const WaitingRoom = lazyImport(() => import('../../waiting-room'), 'default').default;

export const GET_CARE_LAYOUT_ROUTES = {
  Questionnaire: { path: 'questionnaire', title: `Questionnaire` },
  WaitingRoom: { path: 'waiting-room', title: `Waiting Room` },
};

export const GetCareRoutes: Array<RouteObject> = [
  { path: '*', element: <NotFound /> },
  { index: true, element: <GetCare /> },
  {
    path: GET_CARE_LAYOUT_ROUTES.Questionnaire.path,
    element: <Questionnaire />,
  },
  {
    path: GET_CARE_LAYOUT_ROUTES.WaitingRoom.path,
    element: <WaitingRoom />,
  },
];
